import { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";
import getDayOfCurrentMonth from "../../../../utils/getDayOfCurrentMonth";
import { GlobalVariables } from "../../../../GlobalVariables";
import moment from "moment";
import "moment/locale/pt-br";

const GerenciamentoContratoContext = createContext();

const GerenciamentoContratoContextProvider = ({ children }) => {
  const actualDate = moment();
  const [loading, setLoading] = useState(false);
  const [errorsSubmit, setErrorsSubmit] = useState({});
  const [clientInfos, setClientInfos] = useState(null);
  const [commercialPartnerInfos, setCommercialPartnerInfos] = useState(null);
  const [idContract, setIdContract] = useState("");
  const [proposedNumber, setProposedNumber] = useState(
    actualDate.format("YYYYMM").toString()
  );
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [modality, setModality] = useState(null);
  const [listModality, setListModality] = useState([
    { value: GlobalVariables.contract.modality.separate, label: "Avulso" },
    { value: GlobalVariables.contract.modality.recurring, label: "Recorrente" },
  ]);
  const [typeService, setTypeService] = useState(null);
  const [listTypeService, setListTypeService] = useState([]);
  const [taxProfile, setTaxProfile] = useState(null);
  const [taxProfileDetails, setTaxProfileDetails] = useState(null);
  const [listTaxProfile, setListTaxProfile] = useState([]);
  const [modelContract, setModelContract] = useState(null);
  const [listModelContract, setListModelContract] = useState([]);
  const [approvalType, setApprovalType] = useState(null);
  const [listApprovalType, setListApprovalType] = useState([]);
  const [typeReadjustment, setTypeReadjustment] = useState(null);
  const [listTypeReadjustment, setListTypeReadjustment] = useState([]);
  const [dateEmission, setDateEmission] = useState(
    actualDate.format("YYYY-MM-DD")
  );
  const [firstDueDate, setFirstDueDate] = useState(
    moment().add(1, "month").format("YYYY-MM-DD")
  );

  const [dayDueDate, setDayDueDate] = useState(null);
  const [periodicity, setPeriodicity] = useState({
    value: "1",
    label: "Mensal",
  });
  const [listPeriodicity, setListPeriodicity] = useState([
    { value: "1", label: "Mensal" },
    { value: "2", label: "Bimestral" },
    { value: "3", label: "Trimestral" },
    { value: "6", label: "Semestral" },
    { value: "12", label: "Anual" },
  ]);

  const [validity, setValidity] = useState(
    moment().add(1, "year").format("MM/YYYY").toString()
  );
  const [salesmanInfos, setSalesmanInfos] = useState(null);
  const [financialResponsibleEnabled, setFinancialResponsibleEnabled] =
    useState(false);
  const [financialResponsibleInfos, setFinancialResponsibleInfos] =
    useState(null);
  const [
    originalFinancialResponsibleId,
    setOriginalFinancialResponsibleId,
  ] = useState(null);
  const [leadOrigin, setLeadOrigin] = useState(null);
  const [listLeadOrigin, setListLeadOrigin] = useState([]);
  const [saleType, setSaleType] = useState(null);
  const [listSaleType, setListSaleType] = useState([]);
  const [totalService, setTotalService] = useState("0,00");
  const [itemsTable, setItemsTable] = useState([]);
  const [typePayment, setTypePayment] = useState(null);
  const [listTypePayment, setListTypePayment] = useState([]);
  const [generateBillet, setGenerateBillet] = useState(true);
  const [bank, setBank] = useState(null);
  const [listBank, setListBank] = useState([]);
  const [typeBillet, setTypeBillet] = useState(null);
  const [listBillet, setListBillet] = useState([
    { value: "hibrido", label: "CNAB/PIX" },
    { value: "cnab", label: "CNAB" },
    { value: "pix", label: "PIX" },
  ]);
  const [issueNfse, setIssueNfse] = useState(true);
  const [generateFinancialStatement, setGenerateFinancialStatement] =
    useState(true);
  const [sendByEmail, setSendByEmail] = useState(true);
  const [attachNfse, setAttachNfse] = useState(true);
  const [attachFinancialStatement, setAttachFinancialStatement] =
    useState(true);
  const [applyBillingRule, setApplyBillingRule] = useState(true);
  const [attachBillet, setAttachBillet] = useState(true);
  const [arrachExpense, setArrachExpense] = useState(true);
  const [uploadFilesAttachment, setUploadFilesAttachment] = useState([]);
  const [observation, setObservation] = useState("");
  const [regimeCompetency, setRegimeCompetency] = useState({
    label: "Competência e Vencimento no mesmo mês",
    value: "atual",
  });
  const [regimeCompetencyList, setRegimeCompetencyList] = useState([
    {
      label: "Competência e Vencimento no mesmo mês",
      value: "atual",
    },
    {
      label: "Competência em mês anterior ao Vencimento",
      value: "anterior",
    },
    {
      label: "Competência em mês posterior ao Vencimento",
      value: "posterior",
    },
  ]);
  const [selectService, setSelectService] = useState(null);
  const [valueService, setValueService] = useState("0,00");
  const [amountService, setAmountService] = useState("1");
  const [perfilTributarioLinhaModal, setPerfilTributarioLinhaModal] =
    useState(null);
  const [errorsSubmitTypeService, setErrorsSubmitTypeService] = useState({});
  const [reasonForCancellation, setReasonForCancellation] = useState(null);
  const [cancelFrom, setCancelFrom] = useState(null);
  const [listCancelFrom, setListCancelFrom] = useState(null);
  const [formOfPayment, setFormOfPayment] = useState(null);
  const [listFormOfPayment, setListFormOfPayment] = useState([]);
  const [itensInstallments, setItensInstallments] = useState([]);
  const [savedAttachments, setSavedAttachments] = useState([]);
  const [contractCanceled, setContractCanceled] = useState(false);
  const [contractStatus, setContractStatus] = useState("");
  const [disabledPaymentOptions, setDisabledPaymentOptions] = useState(false);
  const [historicContracts, setHistoricContracts] = useState([]);
  const [valueInNote, setValueInNote] = useState(false);

  // Listagem
  const [client, setClient] = useState(null);
  const [initialDate, setInitialDate] = useState(
    formatDate({
      date: getDayOfCurrentMonth("first"),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [finalDate, setFinalDate] = useState(
    formatDate({
      date: getDayOfCurrentMonth("last"),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [typeContract, setTypeContract] = useState({
    label: "Todos",
    value: "all",
  });
  const [typeStatus, setTypeStatus] = useState({
    label: "Todos",
    value: "all",
  });
  const [typePorDataDe, setTypePorDataDe] = useState({
    label: "Emitidos",
    value: "emissao",
  });
  const [numeroContrato, setNumeroContrato] = useState("");

  const [disabledButtonSearch, setDisabledButtonSearch] = useState(false);
  const [mainLoading, setMainLoading] = useState(false);
  const [itensTable, setItensTable] = useState([]);

  const [openEmail, setOpenEmail] = useState(false);

  const [listTypeContract, setListTypeContract] = useState([]);
  const [idTypeContract, setIdTypeContract] = useState(null);

  const [issueType, setIssueType] = useState(true);
  const [modalCancelamentoContratoOpen, setModalCancelamentoContratoOpen] =
    useState(false);

  const [modalReativacaoContratoOpen, setModalReativacaoContratoOpen] =
    useState(false);

  const [initialBillingInformation, setInitialBillingInformation] =
    useState(null);

  const [billingRule, setBillingRule] = useState(null);

  const [classificacaoOptions, setClassificacaoOptions] = useState([]);
  const [indicadorOptions, setIndicadorOptions] = useState([]);
  const [codTributacaoOptions, setCodTributacaoOptions] = useState([]);
  const [nbsOptions, setNbsOptions] = useState([]);
  const [servicosOptions, setServicosOptions] = useState([]);
  const [progressoConfiguracoesNfse, setProgressoConfiguracoesNfse] =
    useState(null);

  return (
    <GerenciamentoContratoContext.Provider
      value={{
        loading,
        setLoading,
        errorsSubmit,
        setErrorsSubmit,
        clientInfos,
        setClientInfos,
        commercialPartnerInfos,
        setCommercialPartnerInfos,
        idContract,
        setIdContract,
        proposedNumber,
        setProposedNumber,
        cpfCnpj,
        setCpfCnpj,
        modality,
        setModality,
        listModality,
        setListModality,
        taxProfile,
        setTaxProfile,
        taxProfileDetails,
        setTaxProfileDetails,
        listTaxProfile,
        setListTaxProfile,
        typeService,
        setTypeService,
        listTypeService,
        setListTypeService,
        modelContract,
        setModelContract,
        listModelContract,
        setListModelContract,
        approvalType,
        setApprovalType,
        listApprovalType,
        setListApprovalType,
        typeReadjustment,
        setTypeReadjustment,
        listTypeReadjustment,
        setListTypeReadjustment,
        dateEmission,
        setDateEmission,
        firstDueDate,
        setFirstDueDate,
        dayDueDate,
        setDayDueDate,
        periodicity,
        setPeriodicity,
        listPeriodicity,
        setListPeriodicity,
        validity,
        setValidity,
        salesmanInfos,
        setSalesmanInfos,
        financialResponsibleEnabled,
        setFinancialResponsibleEnabled,
        financialResponsibleInfos,
        setFinancialResponsibleInfos,
        originalFinancialResponsibleId,
        setOriginalFinancialResponsibleId,
        leadOrigin,
        setLeadOrigin,
        listLeadOrigin,
        setListLeadOrigin,
        saleType,
        setSaleType,
        listSaleType,
        setListSaleType,
        totalService,
        setTotalService,
        itemsTable,
        setItemsTable,
        typePayment,
        setTypePayment,
        listTypePayment,
        setListTypePayment,
        generateBillet,
        setGenerateBillet,
        bank,
        setBank,
        listBank,
        setListBank,
        typeBillet,
        setTypeBillet,
        listBillet,
        setListBillet,
        issueNfse,
        setIssueNfse,
        generateFinancialStatement,
        setGenerateFinancialStatement,
        sendByEmail,
        setSendByEmail,
        attachNfse,
        setAttachNfse,
        attachFinancialStatement,
        setAttachFinancialStatement,
        applyBillingRule,
        setApplyBillingRule,
        attachBillet,
        setAttachBillet,
        arrachExpense,
        setArrachExpense,
        uploadFilesAttachment,
        setUploadFilesAttachment,
        observation,
        setObservation,
        regimeCompetency,
        setRegimeCompetency,
        regimeCompetencyList,
        setRegimeCompetencyList,
        selectService,
        setSelectService,
        valueService,
        setValueService,
        amountService,
        setAmountService,
        perfilTributarioLinhaModal,
        setPerfilTributarioLinhaModal,
        errorsSubmitTypeService,
        setErrorsSubmitTypeService,
        reasonForCancellation,
        setReasonForCancellation,
        cancelFrom,
        setCancelFrom,
        listCancelFrom,
        setListCancelFrom,
        formOfPayment,
        setFormOfPayment,
        listFormOfPayment,
        setListFormOfPayment,
        itensInstallments,
        setItensInstallments,
        savedAttachments,
        setSavedAttachments,
        disabledPaymentOptions,
        setDisabledPaymentOptions,
        historicContracts,
        setHistoricContracts,
        valueInNote,
        setValueInNote,
        issueType,
        setIssueType,
        modalCancelamentoContratoOpen,
        setModalCancelamentoContratoOpen,
        modalReativacaoContratoOpen,
        setModalReativacaoContratoOpen,
        classificacaoOptions,
        setClassificacaoOptions,
        indicadorOptions,
        setIndicadorOptions,
        codTributacaoOptions,
        setCodTributacaoOptions,
        nbsOptions,
        setNbsOptions,
        servicosOptions,
        setServicosOptions,
        progressoConfiguracoesNfse,
        setProgressoConfiguracoesNfse,

        // Listagem
        client,
        setClient,
        typeContract,
        setTypeContract,
        typeStatus,
        setTypeStatus,
        initialDate,
        setInitialDate,
        finalDate,
        setFinalDate,
        numeroContrato,
        setNumeroContrato,
        typePorDataDe,
        setTypePorDataDe,
        disabledButtonSearch,
        setDisabledButtonSearch,
        mainLoading,
        setMainLoading,
        itensTable,
        setItensTable,
        contractCanceled,
        setContractCanceled,
        contractStatus,
        setContractStatus,
        openEmail,
        setOpenEmail,
        listTypeContract,
        setListTypeContract,
        idTypeContract,
        setIdTypeContract,
        initialBillingInformation,
        setInitialBillingInformation,
        billingRule,
        setBillingRule,
      }}
    >
      {children}
    </GerenciamentoContratoContext.Provider>
  );
};

export { GerenciamentoContratoContext, GerenciamentoContratoContextProvider };
